export default "__VITE_ASSET__fHy_ipog__"